import { Observable } from "rxjs";
import { getReporteAereoResponse, listarNaveViajeeResponse, listarNaveViajeeResponseDTO, listarReporteEdiResponse, reporteClienteNaveResponse, reporteDepositoAlmacenResponse } from "../domain/reportes-operacion.response";
import { getReporteAereoRequest, listarReporteEdiRequest, reporteClienteNaveRequest, reporteDepositoAlmacenRequest } from "../domain/reportes-operacion.request";

export abstract class ReporteOperacionRepository {

    abstract reporteDepositoAlmacen(request: reporteDepositoAlmacenRequest): Observable<reporteDepositoAlmacenResponse>
    abstract reporteClienteNave(request: reporteClienteNaveRequest): Observable<reporteClienteNaveResponse>
    abstract ListarNaveViaje(): Observable<listarNaveViajeeResponse>
    abstract listarReporteEdi(request: listarReporteEdiRequest): Observable<listarReporteEdiResponse>
    abstract reporteAereoGp(request: getReporteAereoRequest): Observable<getReporteAereoResponse>

}